export default __webpack_public_path__ + "static/media/gallery_09.f8b74611.jpg";